import { FC } from 'react'
import styled from 'styled-components'

const DividerContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 48px 0 24px;
  width: 100%;
  height: 18px;
  font-size: 12px;
  background: rgb(248, 248, 248);
`

const Divider: FC = () => {
  return (
    <DividerContainer>
      【 收藏本页 】 【 打印文件 】 【 关闭窗口 】
    </DividerContainer>
  )
}

export default Divider
